import React, { memo, useEffect, useState } from "react";
import {
  Card,
  Col,
  Form,
  InputGroup,
  Row
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "./index.css";

import { Creators as ImaOperationsActions } from "../../store/ducks/imaOperations";

const FilterImaOperations = ({
  funcs: { setImaOperations }
}) => {
  const { t } = useTranslation();
  const [operations, setOperations] = useState(["B"]);

  const [operationOptions] = useState([
    { value: "E", label: t("Title.ImaReport.Operation.Enter") },
    { value: "B", label: t("Title.ImaReport.Operation.Fraud") },
    { value: "D", label: t("Title.ImaReport.Operation.Discharge") },
    { value: "M", label: t("Title.ImaReport.Operation.Maintenance") }
  ]);

  useEffect(() => {
    setImaOperations(operations);
  }, [operations]); /* eslint-disable-line */

  return (
    <Card>
      <Card.Header>{t("Title.ImaReport.OperationFilter")}</Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <div className="filter-ima-operations-fields">
              <Form.Group>
                <InputGroup className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text><i className="fas fa-exchange-alt" /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <Select
                    className="menu-outer-bottom filter-ima-operations-form-control"
                    classNamePrefix="select"
                    isMulti
                    placeholder={t("Placeholder.ImaReport.Operation")}
                    onChange={e => setOperations((e || []).map(item => item.value))}
                    options={operationOptions}
                    value={operationOptions.filter(x => operations.includes(x.value))}
                  />
                  <div className="filter-ima-operations-form-control-shaddow" />
                </InputGroup>
              </Form.Group>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, ImaOperationsActions), dispatch)
});

export default connect(null, mapDispatchToProps)(memo(FilterImaOperations));
